import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../../app/services/auth.service';
import { AWSLambda } from '../../AWSLambda.service';
import { Auth } from 'aws-amplify';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class BillingService {

  lambda = inject(AWSLambda);
  authService = inject(AuthService);
  private datePipe = inject(DatePipe);

  async init() {
    await this.authService.refresh();
  }

  async getBills(bill_type: string, from: string, to: string) {
    let today = new Date();
    today.setDate(1); // First day of the current month

    let lastDay = new Date(today);
    lastDay.setMonth(lastDay.getMonth() + 1);
    lastDay.setDate(0); // Last day of the current month

    let todayStr = from == "" ? null : from;
    let lastDayStr = to == "" ? null : to;
    const owner = this.authService.getUser().username;
    let bills = await this.lambda.getLambdaFunction(
      'lambda',
      '/holded/api',
      {
        queryStringParameters: {
          method: bill_type,
          owner: owner,
          fecha_inicio: from,
          fecha_fin: to
        }
      }
    ) || []; 
    
    var response = []
    
    for (let bill of bills) {
      response.push({
        "type": bill_type == 'invoice' ? 'ESIM' : 'CALLS',
        "factura": bill.docNumber,
        "fecha": parseInt(bill.date)*1000,
        "id": bill.id,
        "situacion": bill.status,
        "total": bill.total
      })
    }
    return response;
  }

  async getBill(bill_type: string, factura: string) {
    const bill = await this.lambda.getLambdaFunction(
      'lambda',
      '/holded/api',
      {
        queryStringParameters: {
          method: bill_type == "ESIM" ? "invoice" : "salesreceipt",
          factura: factura
        }
      }
    );
    return bill;
  }
}
